import { createAction } from 'redux-actions';
import { actionKey } from '../constants';

export const initialize = createAction(
  `${actionKey}.INITIALIZE`,
  (deviationId: number) => ({ deviationId })
);

export const initializeSuccess = createAction(
  `${actionKey}.INITIALIZE_SUCCESS`,
  (payload: {
    deviationId: number;
    tags: string[];
    recommendedTags: string[];
  }) => payload
);

export const initializeError = createAction(
  `${actionKey}.INITIALIZE_ERROR`,
  (errorMessage: string) => ({ errorMessage })
);

export const deinitialize = createAction(
  `${actionKey}.DEINITIALIZE`,
  () => ({})
);

// Boost actions are now handled by the existing awardBadge action in coreBadge/redux
